import React from "react";
export var TableDraggableContext = React.createContext({
    isDragging: false,
    placeholder: null,
});
//# sourceMappingURL=TableDraggableContext.js.map